export default __webpack_public_path__ + "static/media/2857.dd157963.png";